export default __webpack_public_path__ + "62d46eb554d38d10592d1b3b56e93a98.png";